import React, {Fragment} from 'react';
import {connect} from 'react-redux';

import {bindActionCreators} from "redux";
import {createTimelineComment, deleteTimelineComment, updateTimelineComment} from "../../../creators/timeline.comment";
import {createSubComment, updateSubComment} from "../../../creators/comments.subComment";
import {fetchTimelineComments, resetTimelineComments,} from "../../../creators/timeline.comments";
import {timelineCommentByParentId,} from "../../../selectors/timelineComments";

import Comment from './components/Comment';
import _ from 'lodash';
import {SpinLoader} from "../Loader";
import CommentEditor from "./components/CommentEditor/CommentEditor";
import {Can} from "../../../ability-context";
import {fetchUserFriends} from "../../../creators/user.friends";

class TimelineComments extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            parentId: this.props.parentId || 0,
            page: 1,
            limit: 3,
            sort: "-createdAt"
        };
        this.initialSubCommentAnswer = {
            owner: {},
            commentId: ""
        };
        this.state = {
            edit : {},
            isNextComment: false,
            showSubComment: 0,
            filter: this.filter,
            subCommentAnswer: this.initialSubCommentAnswer,
            isAnsweringComment: false,
        };
        this.fetchComments = this.fetchComments.bind(this);
        this.commentsNext = this.commentsNext.bind(this);
        // this.updateMediaComment = this.updateMediaComment.bind(this);
        this.deleteMediaComment = this.deleteMediaComment.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetSubCommentAnswer = this.resetSubCommentAnswer.bind(this);
        this.handleSubCommentAnswer = this.handleSubCommentAnswer.bind(this);
        this.handleSubmitEdit = this.handleSubmitEdit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);

        this.fetchComments(this.state.filter);
        if(this.props.currentUserInitialized && this.props.currentUserId && !this.props.userFriendsInitialized){
            this.props.fetchUserFriends(this.props.currentUserId);
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.parentId !== this.props.parentId) {
    //         // this.props.resetTimelineComments(this.props.timelineCommentKeysByParentId);
    //         this.fetchComments(this.state.filter, false);
    //     }
    // }

    componentWillUnmount() {
        // this.props.resetTimelineComments(this.props.timelineCommentKeysByParentId);
    }

    fetchComments(filter, more) {
        filter = {...filter};
        this.props.fetchTimelineComments(this.props.commentType, this.props.parentId, filter, more);
    }

    commentsNext() {
        let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.fetchComments(newFilter,true);
    }

    // updateMediaComment(id, value) {
    //     this.props.updateTimelineComment(this.props.commentType, this.props.parentId, id, {content: value});
    // }

    deleteMediaComment(id) {
        this.props.deleteTimelineComment(this.props.commentType, this.props.parentId, id);
    }

    handleSubCommentAnswer(commentId, ownerOfSubComment){
        this.setState({subCommentAnswer: {
            owner: ownerOfSubComment,
            commentId
        }});
    }

    resetSubCommentAnswer() {
        this.setState({subCommentAnswer: this.initialSubCommentAnswer, isAnsweringComment: false});
    }

    handleSubmit(value) {
        if(this.state.subCommentAnswer.commentId){
            this.props.createSubComment(this.props.commentType, this.props.parentId, this.state.subCommentAnswer.commentId, value);
            this.setState({isAnsweringComment: true}, () => this.resetSubCommentAnswer());
        } else {
            this.props.createTimelineComment(this.props.commentType, this.props.parentId, value);
            this.setState({subCommentAnswer: this.initialSubCommentAnswer})
        }
    }

    handleSubmitEdit({
                         parentId,
                         parentCommentId,
                         commentId,
                         commentType,
                     }, contentState) {
        if (parentCommentId) {
            this.props.updateSubComment(commentType, parentId, parentCommentId, commentId, contentState);
        }
        else {
            this.props.updateTimelineComment(commentType, parentId, commentId, contentState);
        }

        this.setState({edit:{}});
    }

    handleEdit({
                   parentId,
                   parentCommentId,
                   commentId,
                   text,
                   mentions,
                   commentType
               }){
        this.setState({edit : {
                parentId,
                parentCommentId,
                commentId,
                text,
                mentions,
                commentType
            }});
    }

    render() {
        let canOptions = {
            subject: this.props.parent,
            modelName: "Comment",
            action: "create",
            passThrough: true
        };
        let comments = Array.isArray(this.props.timelineComments) ? [...this.props.timelineComments] : [];
        return (
            <Fragment>
                <div className="column media-comments-container">
                    <div className="comments">
                        <div className="comments-list">
                            {!this.props.timelineCommentsInitialized && _.times(1).map((item, index) => (
                                <Comment key={index} commentsInitialized={false}/>
                            ))}
                            {/*{this.props.timelineCommentsInitialized && !this.props.timelineCommentsLoading && this.props.timelineCommentsTotal === 0 && (*/}
                            {/*    <div className={"no-content"}>Aucun commentaire</div>*/}
                            {/*)}*/}
                            {comments.map((comment) => (
                                <Comment
                                    key={comment._id}
                                    {...comment}
                                    handleEdit={this.handleEdit}
                                    currentUser={this.props.currentUser}
                                    parentId={this.props.parentId}
                                    showSubComment={this.state.showSubComment}
                                    commentsInitialized={this.props.timelineCommentsInitialized}
                                    deleteComment={this.deleteMediaComment}
                                    // updateComment={this.updateMediaComment}
                                    handleSubCommentAnswer={this.handleSubCommentAnswer}
                                    commentType={this.props.commentType}
                                    subCommentAnswer={this.state.subCommentAnswer}
                                    isAnsweringComment={this.state.isAnsweringComment}
                                    isTimeline={true}
                                    handleReport={this.props.handleReport}
                                    timelineCommentsTotal={this.props.timelineCommentsTotal}
                                />
                            ))}
                            {!this.props.timelineCommentsLoading && this.props.timelineCommentsMore && (
                                <div className="more-comments" onClick={() => this.commentsNext()}>
                                    Voir plus de commentaires
                                </div>
                            )}
                            {this.props.timelineCommentsLoading && this.props.timelineCommentsMore && (
                                <div className="more-comments loading" onClick={() => this.commentsNext()}>
                                    <SpinLoader className={"small"}/>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {this.props.commentsAllowed ? (
                    <Can {...canOptions}>
                        {can=>(
                            <CommentEditor
                                mentions={this.props.userFriends}
                                onSubmit={this.handleSubmit}
                                onSubmitEdit={this.handleSubmitEdit}
                                onCancelRespond={()=>{
                                    this.setState({subCommentAnswer: this.initialSubCommentAnswer})
                                }}
                                onCancelEdit={()=>{
                                    this.setState({edit: {}})
                                }}
                                edit={this.state.edit}
                                respondMention={this.state.subCommentAnswer.owner}
                                cannot={!can}
                            />)}
                    </Can>
                ) : (
                    <div className="close-comments">
                        Commentaires fermés par l’auteur
                    </div>
                )}
            </Fragment>
        )
    }
}


const mapStateToProps = (state, props) => {
    return {
        timelineComments: timelineCommentByParentId(state, props).data,
        // timelineCommentKeysByParentId: timelineCommentKeysByParentId(state, props),
        timelineCommentsLoading: timelineCommentByParentId(state, props).loading,
        timelineCommentsSubmitting: timelineCommentByParentId(state, props).submitting,
        timelineCommentsInitialized: timelineCommentByParentId(state, props).initialized,
        timelineCommentsTotal: timelineCommentByParentId(state, props).total,
        timelineCommentsMore: timelineCommentByParentId(state, props).more,

        // timelineComment: state.timelineComment.data,
        // timelineCommentLoading: state.timelineComment.loading,

        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
        currentUserId: state.currentUser.data && state.currentUser.data._id,
        userFriends: state.userFriends.data,
        userFriendsInitialized: state.userFriends.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchTimelineComments,
    resetTimelineComments,

    createTimelineComment,
    updateTimelineComment,
    deleteTimelineComment,

    createSubComment,
    fetchUserFriends,
    updateSubComment,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TimelineComments);
